import { useEffect, useState } from 'react'

interface CampaignData {
  source?: string
  medium?: string
  campaign?: string
  term?: string
  content?: string
  uniqueId?: string // gclid, fbclid, etc.
}

const useTrackingParams = (): CampaignData | null => {
  const [trackingParams, setTrackingParams] = useState<CampaignData | null>(
    null
  )

  useEffect(() => {
    if (typeof window === 'undefined') {
      // Return null if executed on the server
      return
    }

    const parseTrackingParams = (url: string): CampaignData => {
      const params = new URL(url).searchParams

      const campaignData: CampaignData = {
        source: params.get('utm_source'),
        medium: params.get('utm_medium'),
        campaign: params.get('utm_campaign'),
        term: params.get('utm_term'),
        content: params.get('utm_content'),
      }

      // Detect unique identifiers for specific networks
      if (params.has('gclid')) campaignData.uniqueId = params.get('gclid') // Google Ads
      if (params.has('fbclid')) campaignData.uniqueId = params.get('fbclid') // Facebook
      if (params.has('msclkid')) campaignData.uniqueId = params.get('msclkid') // Bing
      if (params.has('li_fat_id'))
        campaignData.uniqueId = params.get('li_fat_id') // LinkedIn
      if (params.has('twclid')) campaignData.uniqueId = params.get('twclid') // Twitter
      if (params.has('ttclid')) campaignData.uniqueId = params.get('ttclid') // TikTok
      if (params.has('epik')) campaignData.uniqueId = params.get('epik') // Pinterest

      return campaignData
    }

    // Get the current URL and parse tracking parameters
    const currentUrl = window.location.href
    const parsedParams = parseTrackingParams(currentUrl)
    setTrackingParams(parsedParams)
  }, [])

  return trackingParams
}

export default useTrackingParams
